export const GENDER_OPTIONS = [
  { title: 'Male', value: 'M' },
  { title: 'Female', value: 'F' }
]
